import React, { Component } from 'react';
import { TrevorIcon } from '@trevor/ui-components';
import elements from '../css/module/elements.css';

class SearchInput extends Component {
  constructor(props) {
    super(props);
    this.searchBar = React.createRef();
  }

  componentDidMount() {
    if (this.searchBar) {
      this._timer = setTimeout(() => {
        this.searchBar.current.focus();
      }, 400);
    }
  }

  componentWillUnmount() {
    clearTimeout(this._timer);
  }

  render() {
    const { value, onSearch, placeholder, style, id } = this.props;
    return (
      <div className={elements.searchBar} style={style || {}}>
        <TrevorIcon name="search" />
        <input
          placeholder={placeholder}
          type="text"
          value={value}
          ref={this.searchBar}
          onChange={(e) => onSearch(e.target.value)}
          id={id}
        />
      </div>
    );
  }
}

export default SearchInput;
